module.exports = __webpack_public_path__ + "img/409.369890a2.png";